import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gifted_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // /account (DELETE, wrong-password re-auth check) intentionally returns 401 for a bad
    // password WITHOUT the token itself being invalid — auto-logging out here would hide the
    // "Incorrect password" error from the Delete Account confirmation dialog.
    const url = err?.config?.url || "";
    if (err?.response?.status === 401 && !url.includes("/auth/") && !url.includes("/account")) {
      localStorage.removeItem("gifted_token");
      localStorage.removeItem("gifted_user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
